import React from 'react';

import { useBanners, useIsLoadingBanner } from '../../store/hooks/advertising';
import type { BorderedBannerProps } from '../BorderedBanner';
import { BorderedBanner } from '../BorderedBanner';

type Props = Omit<BorderedBannerProps, 'banner'> & Partial<Pick<BorderedBannerProps, 'banner'>>;

export const ReduxBanner: React.FC<Props> = ({ type, banner: propsBanner, ...props }) => {
  const isLoadingBanner = useIsLoadingBanner(type);
  const banners = useBanners();
  const bannersList = propsBanner || banners?.[type];

  if (!isLoadingBanner && !bannersList) {
    return null;
  }

  return <BorderedBanner banner={bannersList} type={type} {...props} />;
};
